export const COLORS = {
    white: '#fff',
    black: '#000',
    red: '#c1272d',
    yellow: '#fbf98b'
} 